import {
  Component,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
  computed,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ListViewFilterTagComponent } from '@coin/shared/core/feature-legacy-components';
import { ListViewFilterTag, ListViewTagFilterParameter } from '@coin/shared/core/util-models';
import { Observable, of } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'customer-list-view-filter-bar',
  templateUrl: './list-view-filter-bar.component.html',
  styleUrls: ['./list-view-filter-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ListViewFilterTagComponent, V2ButtonComponent, AsyncPipe, TranslatePipe]
})
export class ListViewFilterBarComponent {
  @ViewChildren(ListViewFilterTagComponent) filterItems: QueryList<ListViewFilterTagComponent>;
  readonly tags = input<ListViewFilterTag[]>([]);
  readonly filterParameter$ = input<Observable<ListViewTagFilterParameter[]> | undefined>(undefined);
  filterParameter = toSignal(this.filterParameter$() ?? of([]));
  readonly showReset = input<boolean | undefined>(undefined);
  isResetVisible = computed(() => this.showReset() || (this.filterParameter()?.length ?? 0) > 0);

  @Output() addFilterEvent: EventEmitter<ListViewTagFilterParameter> = new EventEmitter<ListViewTagFilterParameter>();
  @Output() removeFilterEvent: EventEmitter<ListViewTagFilterParameter> =
    new EventEmitter<ListViewTagFilterParameter>();
  @Output() resetFiltersEvent: EventEmitter<void> = new EventEmitter<void>();

  public addFilter(parameter: ListViewTagFilterParameter): void {
    this.addFilterEvent.emit(parameter);
  }

  public removeFilter(parameter: ListViewTagFilterParameter): void {
    this.removeFilterEvent.emit(parameter);
  }

  public resetFilters(): void {
    this.filterItems.forEach(filterItem => filterItem.reset());
    this.resetFiltersEvent.emit();
  }
}
